import Shop from "@/components/game/shop/Shop";
import GameplayHeader from "@/components/game/header/GameplayHeader";
import PlansList from "@/components/game/shop/PlansList";
import Cart from "@/components/game/shop/Cart";
import PlanComparison from "@/components/game/shop/PlanComparison";
import Addons from "@/components/game/shop/Addons";
import store from "@/store";

export default [
	{
		path: "shop",
		name: "Shop",
		components: {
			gameSpace: Shop,
			gameHeader: GameplayHeader,
		},
		redirect: { path: '/game/shop/cart' },
		children: [
			{
				path: "cart",
				component: Cart,
				meta: { scrollable: true },
				beforeEnter: async (to, from, next) => {
					if (store.getters["game/insurance/single"]) {
						next({ path: `/game/shop/plans/` });
					} else {
						store.dispatch("game/plans/deselect");
						next();
					}
				},
			},
			{
				path: "plans",
				meta: { scrollable: true },
				beforeEnter: async (to, from, next) => {
					const id = store.getters["game/insurance/available"][0];
					next({ path: `/game/shop/plans/${id}` });
				},
			},
			{
				path: "plans/:id(\\d+)",
				component: PlansList,
				meta: { scrollable: true },
				beforeEnter: async (to, from, next) => {
					const id = parseInt(to.params.id);

					if (store.getters[`game/insurance/${id}/hasPlan`]) {
						await store.dispatch("game/plans/refund", { id });
					}

					await store.dispatch("game/insurance/browse", { id });
					next();
				},
			},
			{
				path: "plans/addons/",
				meta: { scrollable: true },
				component: Addons,
			},
			{
				path: "plans/compare/",
				component: PlanComparison,
				meta: { scrollable: true },
				async beforeEnter(to, from, next) {
					if (!store.getters["game/plans/available"].length) {
						const id = store.getters["game/insurance/available"][0];
						await store.dispatch("game/insurance/browse", { id });
					}

					next();
				},
			},
			{
				path: "plans/complete/",
				async beforeEnter(to, from, next) {
					await store.dispatch("game/plans/purchase");
					const path = store.getters["game/insurance/single"] ? "/game/shop/complete" : "/game/shop/cart";
					next({ path });
				},
			},
			{
				path: "complete",
				async beforeEnter(to, from, next) {
					store.dispatch("game/risk/track");
					next({ path: "/game/spin" });
				},
			},
		],
	},
];
